export default __webpack_public_path__ + "static/media/alien.f0277e69.png";